import { getInsuranceFund, InsuranceFund } from 'api/v1/information'
import { PRIMARY_CURRENCY } from 'constants/currencies'
import { atom, useAtomValue } from 'jotai'
import { memo } from 'react'
import { toFixed } from '../../../../utils/number'
import { GridBody, GridBox, GridHead, GridItem } from './ContractInfo'
import { DateFormatter } from '../../../../utils/datetime'

export const insuranceFundAtom = atom<Promise<InsuranceFund[]>>(async () => {
  const r = await getInsuranceFund().catch((e) => {
    return { data: [] }
  })
  return r.data.reverse()
})

export const InsuranceFundPanel = memo(() => {
  const insuranceFund = useAtomValue(insuranceFundAtom)

  return (
    <GridBox>
      <GridHead>
        <GridItem xs={4} className="title">
          Time
        </GridItem>
        <GridItem xs={8} className="title">
          Insurance Fund Balance ({PRIMARY_CURRENCY})
        </GridItem>
      </GridHead>
      {insuranceFund.map((item) => (
        <GridBody key={item.createdAt}>
          <GridItem xs={4}>
            {DateFormatter.toISODateTime(item.createdAt)}
          </GridItem>
          <GridItem xs={8}>{toFixed(item.amount, 4, { fixed: true })}</GridItem>
        </GridBody>
      ))}
    </GridBox>
  )
})
